// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { KITCHEN_API_01 } from "../../api/ApiModel";
import { useTheme } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useStyles } from "../../assets/styles/Theme";
import no_image from "../../assets/images/no_image.png";
import {
  Card,
  Typography,
  Button,
  IconButton,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import TableBarIcon from "@mui/icons-material/TableBar";
import { formatDateTime } from "../../utils/common/DateFormat";
import { externalpostApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import SnackbarMessage from "../common/SnackbarMessage";
import {
  MSG_KITCHEN_FAILED,
  MSG_KITCHEN_SUCCESS,
} from "../../utils/sys/Messages";
// imports section End

const KitchenItemCard = ({
  kitchenItem,
  IMAGEBASEURL,
  onOrderReady,
  fetchKitchenItems,
}) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Hooks end

  // Handlers start
  const { date, time } = formatDateTime(kitchenItem.ENDATE);
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Handlers end

  // API calls start

  // Function to handle "Order Ready" action
  const handleOrderReady = async () => {
    const payload = {
      ordercode: String(kitchenItem.ORDERCODE) || "",
      kotseqcode: String(kitchenItem.KOTSEQCODE) || "",
      menucatcode: String(kitchenItem.MENUCATCODE) || "",
      menucode: String(kitchenItem.MENUCODE) || "",
      sts: CON_STATUS_ACTIVE, // Assuming "READY" is the status for confirmation
      locdate: new Date().toISOString(), // Current date in ISO format
    };

    try {
      const response = await externalpostApi(KITCHEN_API_01, payload);
      console.log("Order ready response:", response);
      onOrderReady(kitchenItem); // Notify the parent if needed
      fetchKitchenItems();
      setSnackbarMessage(MSG_KITCHEN_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error marking order as ready:", error);
      setSnackbarMessage(MSG_KITCHEN_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  // API calls end

  return (
    <Card sx={styles.ks_card}>
      <Box sx={styles.ks_card_media_container}>
        {/* <CardMedia
          component="img"
          image={item.image}
          alt="green iguana"
          sx={styles.ks_card_media} 
        /> */}

        {/* {kitchenItem.IMAGEPATH && ( */}
        <CardMedia
          component="img"
          // image={`${IMAGEBASEURL}${kitchenItem.IMAGEPATH.replace("~", "")}`}
          image={
            kitchenItem.IMAGEPATH
              ? `${IMAGEBASEURL}${kitchenItem.IMAGEPATH.replace("~", "")}`
              : no_image
          }
          alt={kitchenItem.MENUNAME}
          sx={styles.ks_card_media}
        />
        {/* )} */}
      </Box>
      <CardContent
        sx={{
          ...styles.ks_card_content,
          borderBottom: `1px solid ${theme.palette.stroke.main}`,
          borderRadius: 0,
          padding: "16px 0px",
        }}
      >
        <Typography sx={styles.ks_card_texts}>
          {kitchenItem.MENUNAME}
        </Typography>
        <Typography sx={styles.ks_card_id}>{kitchenItem.ORDERCODE}</Typography>
      </CardContent>
      {/* <CardContent sx={styles.ks_card_content}>
        <Typography sx={styles.ks_card_note}>*Add extra cheese</Typography>
      </CardContent> */}
      <CardContent sx={styles.ks_card_content}>
        <Typography sx={styles.ks_card_texts}>
          <IconButton sx={styles.ks_card_icons}>
            <CalendarMonthIcon />
          </IconButton>
          {date}
          {/* Date */}
        </Typography>
        <Typography sx={styles.ks_card_text_numbers}>
          <IconButton sx={styles.ks_card_icons}>
            <AddShoppingCartIcon />
          </IconButton>

          {typeof kitchenItem.QTY === "string" && kitchenItem.QTY.trim() !== ""
            ? kitchenItem.QTY
            : "N/A"}

          {/* {typeof kitchenItem?.[0]?.QTY === "string"
            ? kitchenItem[0].QTY
            : kitchenItem?.[0]?.QTY?.name || "0"} */}
        </Typography>
      </CardContent>
      <CardContent sx={styles.ks_card_content}>
        <Typography sx={styles.ks_card_texts}>
          <IconButton sx={styles.ks_card_icons}>
            <AccessTimeFilledIcon />
          </IconButton>
          {time}
        </Typography>
        <Typography>
          <IconButton sx={styles.ks_card_icons}>
            <TableBarIcon />
          </IconButton>
          {/* {typeof kitchenItem.TABLENAME === "string"
            ? kitchenItem.TABLENAME
            : JSON.stringify(kitchenItem.TABLENAME)} */}
          {typeof kitchenItem.TABLENAME === "string" &&
          kitchenItem.TABLENAME.trim() !== ""
            ? kitchenItem.TABLENAME
            : "N/A"}
        </Typography>
      </CardContent>
      <CardContent sx={styles.ks_card_content}>
        <Button
          sx={styles.btn_primary}
          size="small"
          variant="contained"
          onClick={handleOrderReady}
        >
          Order Ready
        </Button>
      </CardContent>

      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Card>
  );
};

export default KitchenItemCard;
